import { motion } from "framer-motion";
import { useLang } from "@/LangContext";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section id="testimonials" className="py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-center gap-3 mb-16 text-xs tracking-[0.25em] uppercase text-muted-foreground">
          <span className="h-px w-10 bg-accent" />
          {t.testimonials.title}
        </div>

        <div className="space-y-16 md:space-y-24">
          {t.testimonials.list.map((item, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className={`max-w-4xl ${i % 2 === 1 ? "md:ml-auto md:text-right" : ""}`}
              data-testid={`testimonial-${i}`}
            >
              <p className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-foreground/90">
                “{item.q}”
              </p>
              <footer className="mt-6 text-sm tracking-widest uppercase text-muted-foreground">{item.a}</footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
